/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "_config/api";

type ManifestacaoTipo = {
  id: number;
  tipoManifestacao: string;
};

interface State {
  isRequesting: boolean;
  successPayload: ManifestacaoTipo[];
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: [],
  errors: []
};

const getTipoManifestacaoSlice = createSlice({
  name: "ouvidoria.manifestacao@getTipoManifestacao",
  initialState,
  reducers: {
    getTipoManifestacaoRequest: (state): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    getTipoManifestacaoSuccess: (
      state,
      action: PayloadAction<ManifestacaoTipo[]>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    getTipoManifestacaoFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.successPayload = [];
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: { type: string }) {
  try {
    const response: AxiosResponse<any> = yield call(
      api.get,
      `api/v1/cidadao/ouvidoria/manifestacoes/tiposManifestacoes`
    );

    yield put(getTipoManifestacaoSuccess(response.data));
  } catch (error) {
    yield put(getTipoManifestacaoFailed([]));
  }
}

export const {
  getTipoManifestacaoRequest,
  getTipoManifestacaoSuccess,
  getTipoManifestacaoFailed
} = getTipoManifestacaoSlice.actions;

export const { reducer } = getTipoManifestacaoSlice;
export const saga = takeLatest(getTipoManifestacaoRequest.type, sagaFunction);
